import { Fulfiller } from '../types/types';
import { callFetch } from '../utils/serviceHelpers';

const BASE_URL = process.env.REACT_APP_FULFILLER_IDENTITY_BASE_URL;

// eslint-disable-next-line import/prefer-default-export
export const getFulfillers = async (): Promise<Fulfiller[]> => callFetch({
  url: `${BASE_URL}/v1/fulfillers`,
});
